<template>
    <el-carousel
        :interval="4000"
        type="card"
        height="260px"
        indicator-position="none"
        class="lower-carousel"
    >
        <el-carousel-item v-for="item in imgList" :key="item.url">
            <div class="carousel-card">
                <img :src="item.url" alt="" />
                <h3 class="carousel-title" @click="checkDetail(item.id)">
                    {{ item.title }}
                </h3>
            </div>
        </el-carousel-item>
    </el-carousel>
</template>

<script>
export default {
    data() {
        return {
            imgList: [
                {
                    title: '兰州生物制品研究所',
                    url: require('../../../../assets/img/mainPage/c1.jpg'),
                    index: 4,
                    id: 'lzsw',
                },
                {
                    title: '美光半导体',
                    url: require('../../../../assets/img/mainPage/c2.jpg'),
                    index: 3,
                    id: 'mgbdt',
                },
                {
                    title: '御锦城',
                    url: require('../../../../assets/img/mainPage/c3.jpg'),
                    index: 5,
                    id: 'znhxt',
                },
            ],
        }
    },
    methods: {
        checkDetail(id) {
            this.$router.push('/caseDetail/' + id)
        },
    },
}
</script>
<style scoped lang="less">
.carousel-card {
    position: relative;
    height: 100%;
    > img {
        width: 100%;
        height: 100%;
    }
    &:hover {
        .carousel-title {
            display: flex;
        }
    }
}
.carousel-title {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    font-size: 18px;
    display: none;
}
</style>
